export enum CHECK_BOX_SIZE {
  SMALL = 'smallCheckbox',
  BIG = 'bigCheckbox',
}
